import script from "./saleContractDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./saleContractDetail.vue?vue&type=script&setup=true&lang=js"

import "./saleContractDetail.vue?vue&type=style&index=0&id=60f17d6e&lang=less"

const __exports__ = script;

export default __exports__